let timeout: any;
export function debounce(func: Function, wait: number = 300) {
  return function () {
    const executeFunction = function () {
      func();
    };
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(executeFunction, wait);
  };
}
